import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {LoginComponent} from "../../login/login.component";
import {Modal} from "bootstrap";
import {NgIf} from "@angular/common";
import {FirebaseAuthenticationService} from "../../firebase/firebase-authentication.service";
import {CheckoutComponent} from "../checkout/checkout.component";
import {Selection} from "../checkout/shopping-card";
import {CheckoutModalService} from "./checkout-modal.service";

@Component({
  selector: 'app-checkout-modal',
  standalone: true,
  imports: [
    FormsModule,
    LoginComponent,
    NgIf,
    CheckoutComponent
  ],
  templateUrl: './checkout-modal.component.html',
  styleUrl: './checkout-modal.component.scss'
})
export class CheckoutModalComponent implements AfterViewInit {

  selection!: Selection;

  @ViewChild('checkoutModal') modalReference!: ElementRef;
  modal!: Modal;

  isAuthenticated!: boolean;

  constructor(
    private checkoutModalService: CheckoutModalService,
    protected authenticationService: FirebaseAuthenticationService
  ) {
    authenticationService.isAuthenticated().subscribe(isAuthenticated => this.isAuthenticated = isAuthenticated);
  }

  ngAfterViewInit() {
    this.modal = new Modal(this.modalReference.nativeElement);

    this.checkoutModalService.getModalState().subscribe(isVisible => {
      if (isVisible) {
        this.show();
      } else {
        this.hide();
      }
    });
  }

  show() {
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }
}
